export const getGradient = (FOUNDATIONS) => {
    return {
        gradient_50: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_50} 0%, #FFF 100%`,
        gradient_100: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_100} 0%, #FFF 100%`,
        gradient_150: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_150} 0%, #FFF 100%`,
        gradient_200: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_200} 0%, #FFF 100%`,
        gradient_250: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_250} 0%, #FFF 100%`,
        gradient_300: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_300} 0%, #FFF 100%`,
        gradient_325: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_325} 0%, #FFF 100%`,
        gradient_350: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_350} 0%, #FFF 100%`,
        gradient_400: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_400} 0%, #FFF 100%`,
        gradient_450: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_450} 0%, #FFF 100%`,
        gradient_500: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_500} 0%, #FFF 100%`,
        gradient_525: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_525} 0%, #FFF 100%`,
        gradient_550: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_550} 0%, #FFF 100%`,
        gradient_600: `180deg, ${FOUNDATIONS.color_chart_bg_opacity_600} 0%, #FFF 100%`,
    };
};
//# sourceMappingURL=gradient.js.map